import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';

export class ApiMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        return '<No Translation>';
    }
}
